import api from '__jsVueApi';

export default {
	async loadDeal({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.deal.get(state.id))
			.then(response => {
				commit('setDeal', response.data);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async addTenant({ state, commit, rootState, dispatch }) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		// state.tenants.map((item) => {
		// 	if(item.)
		// });

		await axios
			.post(api.deal.tenants.post(state.id), state.tenants)
			.then(response => {
				dispatch('loadTenants');
			})
			.catch(err => {
				commit('setTenantsErrors', err.response.data);
				throw new Error(err);
			});
	},
	async addMaintenanceImg({ state, commit, rootState, dispatch }, data) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		var formData = new FormData();
		// formData.append('file', data.blob);
		formData.append('file', data.data);
		await axios
			.post(api.deal.maintenance.attachments.post(data.id), formData)
			.then(response => {
				dispatch('loadMaintenance');
			})
			.catch(err => {
				throw new Error(err);
			});
	},
	async removeMaintenanceImg({ state, commit, rootState, dispatch }, id) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		await axios
			.delete(api.deal.maintenance.attachments.delete(id))
			.then(response => {
				dispatch('loadMaintenance');
			})
			.catch(err => {
				throw new Error(err);
			});
	},
	async changeMaintenanceImg({ rootState, dispatch }, data) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		var formData = new FormData();
		// formData.append('file', data.blob);
		formData.append('file', data.data);
		await axios
			.patch(api.deal.maintenance.attachments.patch(data.id), formData)
			.then(response => {
				dispatch('loadMaintenance');
			})
			.catch(err => {
				throw new Error(err);
			});
	},
	async addMaintenanceImgIndex({ state }, data) {
		state.tempMaintenance[data.index].attachments.push({
			id:   null,
			file: data.data
		});
	},
	async changeMaintenanceImgIndex({ state }, data) {
		state.tempMaintenance[data.index].attachments[data.aIndex].file = data.data;
	},
	async removeMaintenanceImgIndex({ state }, data) {
		state.tempMaintenance[data.index].attachments.splice(data.aIndex, 1);
	},
	async addMaintenance({ state, rootState, dispatch }) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		let tempMaintenance = [];
		for (let i = 0; i < state.tempMaintenance.length; i++) {
			const maintenance = state.tempMaintenance[i];
			if (maintenance.name) {
				tempMaintenance.push(maintenance);
				state.tempMaintenance.splice(i, 1);
			}
		}
		await axios
			.post(api.deal.maintenance.post(state.id), [...state.maintenance, ...tempMaintenance])
			.then(response => {
				dispatch('loadMaintenance');
			})
			.catch(err => {
				throw new Error(err);
			});
	},
	async loadTenants({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.deal.tenants.get(state.id))
			.then(response => {
				commit('setTenants', response.data);
				commit('setTenantsErrors', []);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async loadMaintenance({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.deal.maintenance.get(state.id))
			.then(response => {
				commit('setMaintenance', response.data);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async loadAmortizationAnnually({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.deal.amortization.annually.get(state.id))
			.then(response => {
				commit('setAmortizationAnnually', response.data);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async loadAmortizationMonthly({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.deal.amortization.monthly.get(state.id))
			.then(response => {
				commit('setAmortizationMonthly', response.data);
			})
			.catch(err => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
};
